import { IconWrapper } from '../runtime';
export default IconWrapper('auto-backup', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.5455 13.4543L11.3939 13.4543C13.3855 13.4543 15 11.8398 15 9.84827C15 8.0708 13.714 6.59369 12.0216 6.29665C12.0274 6.20854 12.0303 6.11965 12.0303 6.03009C12.0303 3.80421 10.2259 1.99979 8 1.99979C5.9447 1.99979 4.24873 3.53825 4.00086 5.52641C2.27367 5.98137 1 7.55397 1 9.42405C1 11.6499 2.80443 13.4543 5.0303 13.4543H5.45455",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.00276 13.4998V7.99979M8.00276 7.99979L6.40625 9.5963M8.00276 7.99979L9.59927 9.5963",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});